import styled from '@emotion/styled'

import { spacing, Text, typography } from 'main/ui'

export const SignUpContainer = styled.div`
  display: flex;
  flex-direction: column;

  > :not(:last-child) {
    margin-bottom: ${spacing.majorScale(2)}px;
  }
`

export const StyledText = styled(Text)`
  font-size: ${typography.fontSize.label};
`
